import { jsxs as H, jsx as h } from "react/jsx-runtime";
import { E as a, S as f } from "./icons.types-0722eef5.js";
function p({ title: i, titleId: s, size: c, width: r, height: t, extended: v = !1, ...o }) {
  const l = v ? a : f, n = c ? l[c] : r || l[v ? "s" : "l"], e = c ? l[c] : t || l[v ? "s" : "l"];
  return /* @__PURE__ */ H(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: n,
      height: e,
      "aria-labelledby": s,
      ...o,
      children: [
        i ? /* @__PURE__ */ h("title", { id: s, children: i }) : null,
        /* @__PURE__ */ h(
          "path",
          {
            fill: "#194992",
            d: "M14 58h44c4.211 0 7.102-1.992 8.654-5H5.344c1.552 3.01 4.443 5 8.654 5M66.65 19c-1.553-3.01-4.443-5-8.654-5h-29v5H66.65Z"
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            fill: "#E6E7E8",
            d: "M5.346 53h61.31c.755-1.462 1.176-3.169 1.294-5H4.053c.118 1.831.539 3.538 1.294 5M29 24h38.948c-.118-1.831-.539-3.538-1.294-5H29v5Zm0 9h39v-4.154l-39 .039V33ZM4 38v5h64v-5H4Z"
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            fill: "#194992",
            d: "M67.948 24H29v5h39v-4c0-.34-.031-.668-.052-1ZM4 47c0 .34.032.668.053 1h63.895c.021-.332.052-.66.052-1v-4H4v4Zm25-14h39v5H29v-5ZM14 14c-4.211 0-7.102 1.992-8.654 5-.755 1.462-1.176 3.169-1.294 5-.021.332-.052.66-.052 1v13h25V14H14Z"
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            fill: "#E6E7E8",
            d: "M19 14h-5v10H4.052c-.021.332-.052.66-.052 1v4h10v9h5v-9h10v-5H19V14Z"
          }
        )
      ]
    }
  );
}
export {
  p as GrcGreece
};
